import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const ServicesSection = () => {
  const services = [
    {
      icon: 'ri-tools-line',
      title: 'Emergency Plumbing',
      description: 'Fast response to burst pipes, leaks, and urgent plumbing issues. Available 24/7 for your peace of mind.',
      badge: 'Available 24/7',
    },
    {
      icon: 'ri-fire-line',
      title: 'Boiler Installation & Servicing',
      description: 'Expert boiler installation, repairs, and annual servicing by Gas Safe registered engineers.',
      badge: 'Gas Safe Registered',
    },
    {
      icon: 'ri-temp-hot-line',
      title: 'Central Heating Repairs',
      description: 'Complete system diagnostics, radiator repairs, and heating system maintenance for optimal performance.',
      badge: null,
    },
    {
      icon: 'ri-drop-line',
      title: 'Plumbing Maintenance',
      description: 'Preventative maintenance, tap repairs, toilet fixes, and general plumbing services for your home.',
      badge: null,
    },
  ];

  return (
    <section className="py-24 bg-[#F7F9FB]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-16"
        >
          <p className="text-sm uppercase tracking-wider text-gray-500 mb-3">OUR SERVICES</p>
          <h2 className="text-4xl md:text-5xl font-bold text-[#1A2F4A] lg:w-2/5">
            What We Do Best
          </h2>
        </motion.div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="bg-white rounded-3xl p-8 shadow-sm hover:shadow-xl transition-shadow relative"
            >
              {service.badge && (
                <div className="absolute top-6 right-6 bg-[#1A2F4A] text-white text-xs px-3 py-1.5 rounded-full whitespace-nowrap">
                  {service.badge}
                </div>
              )}
              <div className="w-12 h-12 flex items-center justify-center mb-6">
                <i className={`${service.icon} text-5xl text-[#1A2F4A]`}></i>
              </div>
              <h3 className="text-xl font-bold text-[#1A2F4A] mb-4">{service.title}</h3>
              <p className="text-gray-600 leading-relaxed text-sm">{service.description}</p>
            </motion.div>
          ))}
        </div>

        {/* View All Services Button */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="text-center mt-12"
        >
          <Link
            to="/services"
            className="inline-flex items-center space-x-2 bg-[#1A2F4A] text-white px-8 py-4 rounded-full hover:bg-[#2A3F5A] transition-all shadow-lg group whitespace-nowrap cursor-pointer"
          >
            <span className="font-semibold">View All Services</span>
            <i className="ri-arrow-right-line text-xl group-hover:translate-x-1 transition-transform"></i>
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default ServicesSection;